import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "nav-level2"
}
const _hoisted_2 = { class: "sidebar-heading" }
const _hoisted_3 = {
  key: 0,
  class: "bo-list"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { id: "teleport-sidemenu" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarSingleMenuItem = _resolveComponent("SidebarSingleMenuItem")!
  const _component_SidebarCollapsableItemWrapper = _resolveComponent("SidebarCollapsableItemWrapper")!
  const _component_SidebarAccordionItem = _resolveComponent("SidebarAccordionItem")!

  return (_ctx.subMenu)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.subMenu.title), 1),
        (_ctx.subMenu.subItems?.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subMenu.subItems?.filter((i) => (i.group && i?.items?.length) || (!i.group && !i?.items?.length)), (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (!item.group && !item?.items?.length)
                    ? (_openBlock(), _createBlock(_component_SidebarSingleMenuItem, {
                        key: 0,
                        item: item
                      }, null, 8, ["item"]))
                    : (_openBlock(), _createBlock(_component_SidebarCollapsableItemWrapper, {
                        key: 1,
                        item: item
                      }, null, 8, ["item"]))
                ], 64))
              }), 128)),
              (_ctx.subMenu.subItems?.filter((i) => i.group && !i?.items?.length).length > 0)
                ? (_openBlock(), _createBlock(_component_SidebarAccordionItem, {
                    key: 0,
                    items: _ctx.subMenu.subItems
                  }, null, 8, ["items"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]))
    : _createCommentVNode("", true)
}